import React from "react";
import { Box } from "@mui/material";
import WinningNotificationComponent from "../../components/winning-notification/winning-notification";

function WinningNotificationPage() {
  return <Box>{<WinningNotificationComponent />}</Box>;
}

export default WinningNotificationPage;
